/*
 * @Author: cc
 * @Date: 2020-12-24 16:22:17
 * @LastEditTime: 2022-01-20 15:00:13
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\kuaishou.js
 * @Description: 快手渠道主模块
 */

angular
    .module('editingCenterKuaishouModule', [
        'editKuaishouLeftModule',
        'editKuaishouRouterModule',
        'editKuaishouToBeCompiledModule',
        'editKuaishouPendingModule',
        'editKuaishouSignedModule',
        'editKuaishouDraftBoxModule',
        'editKuaishouDraftModule',
        'editingCenterKuaishouserviceModule'
    ])
    .controller('EditingCenterKuaishouCtrl', [function () {
    }])
    .value('KuaishouConst', {
        mediaType: 25, // 快手渠道的mediaType标识
        draftIdKey: 'KUAISHOUARTICLEID', // 稿件的主键ID
        accountKey: 'accountId', // 账号的主键ID
        serviceidKey: 'mlf_kuaishou', // serviceid的区分
        trench: 'Kuaishou', // 用来区分渠道的标识，各种操作时需要的
        closeListenKey: 'kuaishou', // 关闭编辑页用的
        // 快手渠道常量（包括请求参数、完整渠道变量等常量）
        trial: {
            // 送审参数
            serviceid: 'mlf_kuaishou',
            methodname: 'trialMetaDatas',
        },
        sign: {
            // 签发参数
            serviceid: 'mlf_kuaishou',
            methodname: 'publishDoc',
        },
        draftListQuery: {
            // 发稿单查询参数
            serviceid: 'mlf_appfgd',
            methodname: 'queryFgdByKuaiShouId',
        },
        draftListDB: {
            // 待编发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'kuaiShouDaiBianbatchUpdateFgdUsers',
        },
        draftListDS: {
            // 待审发稿单参数
            serviceid: 'mlf_appfgd',
            methodname: 'kuaiShouDaiShenbatchUpdateFgdUsers',
        },
        delete: {
            // 废稿参数
            serviceid: 'mlf_kuaishou',
            methodname: 'trashMetaDatas',
        },
        // propagandaReview: {
        //     // 宣传部送审参数
        //     serviceid: 'mlf_kuaishou',
        //     methodname: 'trialByPropagandaDepartment',
        // },
        rejection: {
            // 撤稿参数
            serviceid: 'mlf_kuaishou',
            methodname: 'rejectionMetaDatas',
        },
        retraction: {
            // 取消签发参数
            serviceid: 'mlf_kuaishou',
            methodname: 'withdraw',
        }
    });
